import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {PharmacyModel} from "../../models/Pharmacy.model";
import {AppThunk, RootState} from "../../app/store";
import http from "../../shared/utils/http";


export interface PharmacyState {
    selectPharmacy?: PharmacyModel
    employees?: any[]

}

const initialState: PharmacyState = {

};


export const pharmacySlice = createSlice({
    name: 'pharmacy',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {

        setSelectedPharmacy: (state, action: PayloadAction<PharmacyModel>) => {
            state.selectPharmacy = action.payload
        },
        resetSelectedPharmacy: (state) => {
            state.selectPharmacy = undefined;
        },
        setEmployees: (state, action: PayloadAction<any[]>) => {
            state.employees = action.payload;
        },
        resetEmployees: (state) => {
            state.employees = undefined;
        },
    },
});

export const {
    setSelectedPharmacy,
    setEmployees,
    resetSelectedPharmacy,
    resetEmployees
} = pharmacySlice.actions;


export const selectedPharmacyAction =
    (res: PharmacyModel): AppThunk =>  (dispatch, getState) => {
            dispatch(setSelectedPharmacy(res))
            localStorage.setItem('pharmacy', res.idDocument)
        };




export const selectSelectedPharmacy = (state: RootState) => state.pharmacy.selectPharmacy;




export default pharmacySlice.reducer;
